import { render, staticRenderFns } from "./IdCardAuth.vue?vue&type=template&id=220f4b14&"
import script from "./IdCardAuth.vue?vue&type=script&lang=js&"
export * from "./IdCardAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports